import React from "react";
import { Link } from "react-router-dom";
import configData from "../config/config.json";
import "../css/Modal.css";

function CompanySubscriptionModal({ setShow }) {
    return (
		<div className="modalContainer hide-scrollbar">
		  <h1 style={{letterSpacing: "1.25px", textAlign: "center", marginBottom: "20px"}}>Subscription Required</h1>
		  <p>
		    Access to some profiles require a subscription.
		    If you already have an account&nbsp;
		    <Link className="link-primary" to="/sign_in">
                Sign In
            </Link>&nbsp;Or&nbsp;<Link className="link-primary" to="/sign_up">
                Sign up
            </Link> to see all profiles.
		    If you have further questions contact&nbsp;
		    <a href={"mailto:"+configData.MAIL.TO} target="_blank" rel="noreferrer" >{configData.MAIL.TO}</a> 
		    &nbsp;for more information.
		  </p>
		  <br />
		  <button style={{ marginLeft: "45%"}} onClick={(e) => setShow(false)} >Dismiss</button>
		</div>
    );
}

export default CompanySubscriptionModal;